<template>
  <div class="container productDetail"  v-wechat-title="productDateils.name">
    <follow @follow="followFn"></follow>
    <div id="cup">
      <div class="maininfo d_jump" id="Glide">
        <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto;">
          <div class="swiper-wrapper swiper_height">
            <div class="swiper-slide" v-for="(item,index) in bannerList" :key="index"><img v-lazy="item" @click="preview(item, index, 'banner')"/></div>
          </div>
          <div id="proSwiperPagination" class="swiper-pagination swiper-pagination-fraction"
               v-if="bannerList && bannerList.length > 0">
            <div class="pro_page">
              {{activeIndex+1}} / {{bannerList.length}}
            </div>
          </div>
        </div>
        <van-skeleton
          title
          :row="3"
          :loading="loading"
        >
          <div class="pro_price">
            <div class="xian">
              <span class="smallprice" v-if="productDateils.sales_price">
                <sub>¥</sub>
                <b>{{productDateils.sales_price ? String(parseFloat(productDateils.sales_price).toFixed(2)).slice(0, String(parseFloat(productDateils.sales_price).toFixed(2)).indexOf('.')) : '0'}}</b>
                <sup>{{productDateils.sales_price ? String(parseFloat(productDateils.sales_price).toFixed(2)).slice(String(parseFloat(productDateils.sales_price).toFixed(2)).indexOf('.'), String(parseFloat(productDateils.sales_price).toFixed(2)).length) : '.00'}}</sup>
              </span>
              <div class="countdown">
                <span>{{timeVal}}</span>
                <van-count-down :time="time" @finish="finishFn">
                  <template v-slot="timeData">
                    <span class="item">{{ timeData.hours | timef}}</span>:<span class="item">{{ timeData.minutes | timef}}</span>:<span class="item">{{ timeData.seconds | timef}}</span>
                  </template>
                </van-count-down>
              </div>
            </div>
            <div class="yuan">
              <span class="smallprice" v-if="productDateils.cost_price">
                ¥{{productDateils.cost_price ? parseFloat(productDateils.cost_price).toFixed(2) : '0'}}
              </span>
            </div>
          </div>
          <div class="pro_tit">
            {{productDateils.name}}
            <!--<van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>&lt;!&ndash; v-if="actopen.is_pre_item == 1"&ndash;&gt;-->
          </div>
        </van-skeleton>
      </div>
      <!--<div class="pro_actinfo">-->
        <!--<div class="header">-->
          <!--<div class="tag">优惠</div>-->
          <!--<div class="title">-->
            <!--<div class="acttag">-->
              <!--新人专享-->
            <!--</div>-->
            <!--&lt;!&ndash;            <van-tag color="#FEE9E6" text-color="#F12A0E">购物优惠券</van-tag>&ndash;&gt;-->
            <!--109元现金券-->
          <!--</div>-->
          <!--<div class="lqbtn" v-if="is_get_coupon == 1">已领取</div>-->
          <!--<div class="lqbtn atc" @click="getCoupon" v-else>领券</div>-->
        <!--</div>-->
      <!--</div>-->

      <div class="pro_arg">
        <van-skeleton
          title
          :row="3"
          :loading="loading"
        >
          <div class="pro_arg_tit">产品信息</div>
          <div class="pro_arg_list">
            <div class="pro_mess" v-if="!isshow">
              <div class="pro_arg_item">
                <span>【产品品牌】</span>
                <span>{{productDateils.brand}}</span>
              </div>
              <div class="pro_arg_item">
                <span>【产品规格】</span>
                <span>{{specification}}</span>
              </div>
            </div>
            <div class="pro_mess" v-if="isshow">
              <div class="pro_arg_item">
                <span>【产品品牌】</span>
                <span>{{productDateils.brand}}</span>
              </div>
              <div class="pro_arg_item">
                <span>【产品规格】</span>
                <span>{{specification}}</span>
              </div>
              <div class="pro_arg_item">
                <span>【产品功效】</span>
                <span>{{productDateils.usescope}}</span>
              </div>
              <div class="pro_arg_item">
                <span>【使用方法】</span>
                <span>{{productDateils.usemethod}}</span>
              </div>
              <div class="pro_arg_item">
                <span>【使用年限】</span>
                <span>{{productDateils.useyear}}</span>
              </div>
            </div>
            <div class="pro_arg_more" @click="stretch">
              {{isshow===false?'展开':'收起'}}
              <van-icon name="arrow-down" v-if="isshow===false"/>
              <van-icon name="arrow-up" v-else/>
            </div>

          </div>
        </van-skeleton>
      </div>

      <div class="pro_details d_jump">
        <div class="pro_details_tit">
          商品详情
        </div>
        <div class="pro_details_con" v-html="productDateils.description">
          <!--<img src="../assets/images/product.png"/>-->
        </div>
      </div>
      <div class="d_jump">

      </div>
    </div>
    <div class="pro_goods_menu footerIOS">
      <div class="button buy"  @click="buy(1)" v-if="productDateils.islimit == 0 && productDateils.canbuycnt > 0">
        立即购买
      </div>
      <div class="button buy disabled" v-else>
        无货
      </div>
      <div class="button shopcart"  @click="share">
        分享好友
      </div>
    </div>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png">
    </div>
    <van-marquee :itemid="$route.query.itemid"></van-marquee>

    <van-overlay
      :show="showshare"
      z-index="99"
    >
    </van-overlay>
    <div class="sharecontainer" v-if="showshare === true">
      <img src="../../assets/images/sharemc.png"/>
      <van-button round plain  type="danger" class="know"  @click="showshare = false">我知道了</van-button>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import { Rate, Divider, Overlay, Sku, Loading, ImagePreview, Tag, Skeleton } from 'vant'
import productItem from '../../components/common/productItem'
import follow from '../common/follow'
import vanMarquee from '../common/vanMarquee'
import { basepath, isWeixin, fenxiang, isApp, wxAjaxData, getQueryString } from '../../assets/common/js/config'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)

export default {
  name: 'ylproductDetail',
  components: {
    [Rate.name]: Rate,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [Sku.name]: Sku,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    productItem,
    follow,
    vanMarquee
  },
  data () {
    return {
      icon: 'play',
      follow: null,
      recCount: 0,
      loading: true,
      sureGray: true,
      // isShare: false,
      imgShow: false,
      posterList: [],
      posterUrlBase: '',
      posterUrl: [],
      posterImgHeight: '',
      qrcode: '',
      posterIndex: 0,
      // loadingShow: false,
      postImgData: '',
      posterDataLoading: false,
      title: '',
      posterSwiperOption: {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true
      },
      showsku: false,
      showshare: false,
      activeIndex: 0,
      bannerSwiper: null,
      galleryThumbs: null,
      islove: false,
      isshow: false,
      isoverseas: false, // 判断该商品是不是海外商品
      value: 5,
      propic: null,
      bannerList: [],
      show: false,
      specification: '',
      ceil: false,
      zIndex: false,
      wuIndex: 0,
      daiIndex: 0,
      zcIndex: 0,
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      buyType: null, // 判断点击‘加入购物袋’或‘立即购买’，0加入购物袋  1立即购买,
      productlist: [],
      productBannerList: [],
      skuValueToast: null,
      productEvaluate: {},
      productDateils: {},
      swiperOption: {
        slidesPerView: 3.6,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      },
      // is_buy: 0,
      // is_get_coupon: 0,
      shareinfo: {
        title: '底价大牌，限时秒杀',
        desc: '和我一起抢3.8整点福利，全网底价大牌！快点来！',
        img: basepath + '/static/images/ms.png',
        shareUrl: basepath + '/Wxmall/WeChat/share' + wxAjaxData
      },
      time: 0,
      timeVal: ''
    }
  },
  computed: {
    isWap() {
      return getQueryString('pt') && getQueryString('pt') == 'app' ? 2 : isWeixin() ? 1 : 3
    }
  },
  mounted: function () {
    let that = this
    // if (isWeixin()) that.isShare = true
    window.scrollTo(0, 0)
    that.getData()
    that.$nextTick(function () {
      that.bannerSwiper = new Swiper('#pro_pic', {
        autoplay: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function () {
            // console.log(this.activeIndex) // 切换结束时，告诉我现在是第几个slide
            that.activeIndex = this.activeIndex
          }
        }
      })
      that.propic = new Swiper('.comment_pic .swiper-container', {
        slidesPerView: 3.3,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      })
      // window.addEventListener('scroll', that.scrollWatch)
    })
  },
  destroyed: function () {
    // window.removeEventListener('scroll', this.scrollWatch)
    // window.removeEventListener('popstate', this.goBack, false);
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  beforeRouteEnter (to, from, next) {
    next()
  },
  methods: {
    // getCoupon: function () {
    //   var arg = isApp()
    //   if (!isWeixin()) {
    //     if (arg == '') {
    //       if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
    //         this.$router.push({
    //           path: '/login',
    //           query: {
    //             routeval: 'newprodetail'
    //           }
    //         })
    //         return
    //       }
    //     }
    //   }
    //   var url = this.$ajax.collarCoupons_URL
    //   this.$customRequestAjax(url).then(res => {
    //     if (res.data.code === 200) {
    //       this.$toast(res.data.msg)
    //       this.is_get_coupon = 1
    //     }
    //   })
    // },
    getData: function () {
      var url = this.$ajax.getLimitActItem_URL+'?limitid=' + this.$route.query.itemid
      var that = this
      that.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })

      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.loading = false
          that.$toast.clear()
          that.$dialog.close()
          if (res.data.is_invalid == 1) { // 无效
            that.$dialog.confirm({
              // title: '积分使用规则',
              message: '商品过期不存在，请您去首页转转',
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去首页',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              var arg = isApp()
              if (arg == '') {
                that.$router.replace('/')
              } else {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                  type: 'goIndex'
                }))
              }
            })
          } else if (res.data.act_status == 2) {
            that.$dialog.confirm({
              // title: '积分使用规则',
              message: '活动已结束',
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去首页',
              closeOnPopstate: false
            }).then(() => {
              // on confirm
              var arg = isApp()
              if (arg == '') {
                that.$router.replace('/')
              } else {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                  type: 'goIndex'
                }))
              }
            })
          } else {
            f(res.data)
            g(res.data)
          }
        } else {
          that.$dialog.confirm({
            message: res.data.msg,
            className: 'percen_button_alert integral_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去首页',
            closeOnPopstate: false
          }).then(() => {
            // on close
            var arg = isApp()
            if (arg == '') {
              that.$router.replace('/')
            } else {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'goIndex'
              }))
            }
          })
        }
      })
      console.log('json文件调用处理')
      function f (data) {
        that.bannerList = data.iteminfo.img_paths
        that.productDateils = data.iteminfo
        that.$route.meta.title = data.iteminfo.name
        that.info = data
        var begintime = that.parserDate(that.info.begintime) / 1000
        var endtime = that.parserDate(that.info.endtime) / 1000
        var systime = that.info.systime
        var timelen
        if (begintime > systime) {
          that.timeVal = '距开始'
          timelen = begintime - systime
          that.time = timelen * 1000
        } else if (begintime <= systime && endtime >= systime) {
          that.timeVal = '距结束'
          timelen = endtime - systime
          that.time = timelen * 1000
        } else if (endtime < systime) {
          that.timeVal = '已结束'
          timelen = systime - endtime
          that.time = timelen * 1000
        }
      }
      function g (data) {
        fenxiang({
          title: encodeURIComponent(that.shareinfo.title),
          desc: encodeURIComponent(that.shareinfo.desc),
          imgx: that.shareinfo.img,
          type: 'msindex',
          dataStr: 'type=msindex',
          path: 'msindex',
          callback: function () {
            that.showshare = false
          }
        })
      }
    },
    finishFn: function () {
      this.getData()
    },
    parserDate: function (date) {
      if (typeof date !== 'string') {
        return date
      }
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    followFn: function (data) {
      this.follow = data
    },
    loadvideo: function () {
      // @load="loadvideo"
      console.log('onload')
      zymedia('video', {aspectRation: ('100%' / '100%'), 'preload': 'auto', 'hideVideoControlsOnLoad': true})
    },
    itemId: function () {
      let that = this
      // window.scrollTo(0, 0)
      that.recCount = 0
      that.loading = true
      that.bannerList = []
      that.getData()
    },
    preview (items, index, type) {
      var imgArr, newImgArr
      if (type == 'comment') {
        imgArr = [items.path1, items.path2, items.path3, items.path4, items.path5, items.path6]
        newImgArr = []
        imgArr.map(item => {
          if (item && item != undefined) {
            newImgArr.push(item)
          }
        })
      } else if (type == 'banner') {
        newImgArr = this.bannerList
      }
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    scrollWatch: function () {
      let scrolled = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      let scrolledHeight = document.documentElement.scrollHeight - scrolled
      let clientHeight = scrolledHeight - document.documentElement.scrollHeight
      if (this.imgShow && clientHeight <= 0) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
      }
      // 586、1063分别为第二个和第三个锚点对应的距离
      var jump = document.querySelectorAll('.d_jump')
      if (jump[3] && scrolled >= jump[3].offsetTop - 84) {
        this.zIndex = false
        this.ceil = true
        this.navId = 3
      } else if ((jump[3] && scrolled < jump[3].offsetTop - 84) && (jump[2] && scrolled >= jump[2].offsetTop - 84)) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
        this.zIndex = false
        this.ceil = true
        this.navId = 2
      } else if ((jump[2] && scrolled < jump[2].offsetTop - 84) && (jump[1] && scrolled >= jump[1].offsetTop - 84)) {
        this.zIndex = false
        this.ceil = true
        this.navId = 1
      } else if ((jump[1] && scrolled < jump[1].offsetTop - 84) && (jump[0] && scrolled >= jump[0].clientHeight / 4)) {
        console.log(4, jump[1].offsetTop, jump[0].clientHeight)
        this.zIndex = false
        this.ceil = true
        this.navId = 0
      } else {
        this.ceil = false
        var that = this
        setTimeout(function () {
          that.zIndex = true
        })
        this.navId = 0
      }
    },
    presell () {
      this.showPresale = false
      this.onConfirmClicked()
    },
    buy (type) {
      var that = this
      var arg = isApp()
      if (!isWeixin()) {
        if (arg == '') {
          if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
            that.$router.push({
              path: '/login',
              query: {
                routeval: 'ylproduct'
              }
            })
            return
          }
        }
      }
      // if (that.productDateils.canbuycnt <= 0 || that.productDateils.islimit != 0) {
      //   // 非常抱歉，今日量已抢完，请明日10：00再次开放
      //   this.$dialog.alert({
      //     message: '非常抱歉，今日量已抢完，请明日10:00再来',
      //     className: 'percen_button_alert integral_button_alert',
      //     confirmButtonColor: '#FFFCFC',
      //     confirmButtonText: '确定',
      //     closeOnPopstate: false
      //   }).then(() => {
      //     // on close
      //     this.$dialog.close()
      //   })
      //   return
      // }
      this.buyType = type
      this.onConfirmClicked(arg)
    },
    // shopcart (type) {
    //   var that = this
    //   var arg = isApp()
    //   if (!isWeixin()) {
    //     if (arg == '') {
    //       if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
    //         that.$router.push({
    //           path: '/login',
    //           query: {
    //             routeval: 'newprodetail'
    //           }
    //         })
    //         return
    //       }
    //     }
    //   }
    //   this.buyType = type
    //   this.onConfirmClicked(arg)
    // },
    // 客服
    // keFu: function () {
    //   if (!isWeixin()) {
    //     if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
    //       this.$router.push({
    //         path: '/login',
    //         query: {
    //           routeval: 'productdetail'
    //         }
    //       })
    //     } else {
    //       kefu()
    //     }
    //   } else {
    //     kefu()
    //   }
    // },
    // gocart () {
    //   if (!isWeixin()) {
    //     if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
    //       this.$router.push({
    //         path: '/login',
    //         query: {
    //           routeval: 'productdetail'
    //         }
    //       })
    //     } else {
    //       this.$router.push('/cart')
    //     }
    //   } else {
    //     this.$router.push('/cart')
    //   }
    // },
    stretch () {
      this.isshow = !this.isshow
    },
    share () {
      var arg = isApp()
      if (arg == '') {
        if (isWeixin()) {
          this.showshare = true
        } else {
          this.$toast('关注【创客村】公众号，惊喜享不停')
        }
      } else {
        var obj = {
          type: 'shareFriends',
          title: encodeURIComponent(this.shareinfo.title),
          img: this.shareinfo.img,
          desc: encodeURIComponent(this.shareinfo.desc),
          link: encodeURIComponent(this.shareinfo.shareUrl + '&type=msindex')
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    },
    onConfirmClicked (arg) {
      var that = this
      if (that.timeVal == '距开始') {
        that.$dialog.confirm({
          // title: '签到成功',
          message: '活动还未开始，等会再来吧',
          confirmButtonText: '去首页',
          className: 'percen_button_alert',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        }).then(() => {
          // 点击确认按钮
          var arg = isApp()
          if (arg == '') {
            that.$router.replace('/')
          } else {
            window.ReactNativeWebView.postMessage(JSON.stringify({
              type: 'goIndex'
            }))
          }
        }).catch(() => {
          // on cancel
          this.$dialog.close()
        })
        return
      } else if (that.timeVal == '已结束') {
        that.$dialog.confirm({
          title: '来晚了',
          message: '活动已结束，去看看其他的活动吧',
          confirmButtonText: '去首页',
          className: 'percen_button_alert',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        }).then(() => {
          // 点击确认按钮
          var arg = isApp()
          if (arg == '') {
            that.$router.replace('/')
          } else {
            window.ReactNativeWebView.postMessage(JSON.stringify({
              type: 'goIndex'
            }))
          }
        }).catch(() => {
          // on cancel
          this.$dialog.close()
        })
        return
      }
      that.skuId = that.productDateils.skuid
      that.itemnum = 1
      var urlCheck = that.$ajax.checkOrder_limitAct_URL
      var urlShop = that.$ajax.addShoppingCart_URL
      var data = {
        skuid: that.skuId,
        itemnum: that.itemnum
      }
      if (that.buyType === 0) {
        that.$customRequestAjax.post(urlShop, data).then(res => {
          if (res.data.code === 200) {
            that.$store.commit('ADD_CART_INIT_DATA', 1)
            that.$toast('已成功加入购物车')
          }
        })
      } else if (that.buyType === 1) {
        var ckdata = {
          skuid: that.skuId,
          limitid: that.$route.query.itemid,
          custom_msg_kk: 1
        }
        that.$customRequestAjax.post(urlCheck, ckdata).then(res => {
          if (res.data.code === 200) {
            var shopConfirmResult = {
              skuidArr: [],
              from: 2,
              orderfrom: 1,
              itemNum: [],
              totalmoney: parseFloat(that.productDateils.sales_price) * parseInt(that.itemnum),
              totalnum: that.itemnum
            }
            shopConfirmResult.skuidArr.push(that.skuId)
            shopConfirmResult.itemNum.push(that.itemnum)
            shopConfirmResult.limitid = that.$route.query.itemid
            localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
            sessionStorage.removeItem('choose_integral')
            sessionStorage.removeItem('choose_coupon')
            sessionStorage.removeItem('choose_product')
            sessionStorage.removeItem('oversea_List')
            if (arg == '') {
              that.$router.push('/order?ms=1')
            } else {
              var obj = {
                type: 'msBuy'
              }
              this.$commonburiedPoint({
                data: {
                  scenepoint: window.document.title,
                  scenedesc: window.location.href,
                  url: 'order-confirm'
                },
                rnType: 'msBuy',
                callback: () => {
                  window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                }
              })
            }
          } else {
            this.$dialog.confirm({
              message: res.data.msg,
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去首页',
              closeOnPopstate: false
            }).then(() => {
              var arg = isApp()
              if (arg == '') {
                that.$router.replace('/')
              } else {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                  type: 'goIndex'
                }))
              }
            })
          }
        })
      }
    },
    homeClick: function () {
      var arg = isApp()
      if (arg == '') {
        this.$router.replace('/')
      } else {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'goIndex'
        }))
      }
    }
  },
  filters: {
    timef (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }
  }

}
</script>

<style scoped lang="scss">
  .lqbtn{
    font-size: .13rem;
    border: solid 1px #999;
    float: right;
    margin-right: .15rem;
    height: .25rem;
    padding: 0 .1rem;
    border-radius: .1rem;
    margin-top: .1rem;
    line-height: .25rem;
    text-align: center;
    color:#999;
    background: #ddd;
  }
  .lqbtn.atc{
    background: #fff;
    color:#FC0324;
    border: solid 1px #FC0324;
  }
  .container {
    background: #fff;
    padding-bottom: .49rem;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -moz-flex-direction: column;
    -o-flex-direction: column;
    /*overflow: hidden;*/
    height: 100%;
    flex: 0;
    -webkit-flex: 0;
    -moz-flex: 0;
    -ms-flex: 0;
    -o-flex: 0;
    header {
      height: 0.4rem;
      background: #fff;
      opacity: 0;
      transition: all .45s;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      z-index: 10;
      &.ceiling {
        opacity: 1;
      }
      ul {
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -moz-flex;
        display: -ms-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        padding: 0 0.9rem;
        height: 0.37rem;
        li {
          font-size:0.14rem;
          font-weight:400;
          color:rgba(41,41,41,1);
          line-height:0.37rem;
          &.colorLis {
            font-weight: 500;
          }
          &.colorLis:after {
            content: '';
            display: block;
            width: 86%;
            height: 0.025rem;
            background:linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -webkit-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -moz-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -ms-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -o-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            position: relative;
            bottom: 0.065rem;
            margin: 0 7%;
            /*border-bottom: 0.02rem solid #FC0324;*/
          }
        }
      }
    }
    #cup {
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      /*overflow-y: auto;*/
      /*margin-top: -0.4rem;*/
      margin-bottom: 0.47rem;
    }
    .maininfo {
      padding-bottom: .15rem;
      .swiper-container {
        .swiper-wrapper {
          margin: 0;
          padding: 0;
          /*height: 100%;*/
          .swiper-slide {
            padding: 0;
            margin: 0;
            position: relative;
            img {
              width: 100%;
              display: block;
              border: 0;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -o-transform: translateY(-50%);
            }
          }
        }
        #proSwiperPagination {
          font-size: .12rem;
          width: .34rem;
          color: #fff;
          position: absolute;
          right: 0.11rem;
          left: auto;
          /*<!--margin-left: -.17rem;-->*/
          bottom: .15rem;
          .pro_page {
            /*position: relative;*/
            background: url(../../assets/images/pagebg.png) no-repeat center;
            background-size: 100% 100%;
            padding: 0 0.0385rem 0.01rem;
            white-space: nowrap;
            .swiper-pagination-current {
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top: 0;*/
              /*left: 0;*/
              /*background: #757575;*/
            }
            .swiper-pagination-split {
              margin-left: .02rem;
              margin-right: .02rem;
              /*position: absolute;*/
              /*top: 0;*/
              left: .08rem;
              height: .12rem;
              line-height: .12rem;
              margin-top: .01rem;
              /*background: #757575;*/
              text-align: center;
              font-size: .12rem;
              transform: scale(0.8);
            }
            .swiper-pagination-total {
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top: 0;*/
              left: .14rem;
              /*background: #757575;*/
            }
          }

        }
        .playTab {
          /*font-size: 0;*/
          text-align: center;
          position: absolute;
          bottom: 0.15rem;
          z-index: 1;
          left: 0;
          right: 0;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          span {
            width: 0.47rem;
            height: 0.22rem;
            text-align: center;
            background:rgba(249,249,249,1);
            border-radius:0.11rem;
            border:0.01rem solid rgba(224,225,224,1);
            font-size:0.11rem;
            font-weight:400;
            color:rgba(53,53,53,1);
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -o-flex;
            display: -ms-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -o-align-items: center;
            -ms-align-items: center;
            justify-content: center;
            -webkit-justify-content: center;
            -moz-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            b {
              font-weight: 400;
              transform: scale(0.98);
              -webkit-transform: scale(0.98);
              -moz-transform: scale(0.98);
              -ms-transform: scale(0.98);
              -o-transform: scale(0.98);
            }
            &:first-of-type {
              margin-right: 0.045rem;
            }
            &:last-of-type {
              margin-left: 0.045rem;
            }
          }
        }
      }
      .pro_price {
        margin-top: .15rem;
        margin-left: .15rem;
        position: relative;
        .shareCommentPosters {
          position: absolute;
          right: 0.2rem;
          top: 0;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          .comment {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
          .posters {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
          .share {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
        }
        .xian {
          color: #FC0324;
          font-size: .14rem;
          text-align: left;
          position: relative;
          .smallprice {
            font-size: 0;
            line-height: .2rem;
          }
          b {
            font-size: .21rem;
            line-height: .2rem;
            font-weight: 500;
          }
          sub {
            font-weight: normal;
            font-size: .12rem;
            vertical-align: baseline
          }
          sup {
            font-size: .11rem;
            vertical-align: baseline;
            font-weight: 500;
          }
          .bigprice {
            font-size: 0;
            line-height: .2rem;
            b {
              font-size: .21rem;
              line-height: .2rem;
              font-weight: 500;
            }
          }
          .countdown {
            position: absolute;
            right: 0;
            top: 0;
            display: flex;
            align-items: center;
            font-size: .16rem;
            padding-right: .1rem;
            .van-count-down{
              margin-left: .1rem;
            }
            .item {
              display: inline-block;
              width: 22px;
              margin-right: 2px;
              color: #fff;
              font-size: .14rem;
              text-align: center;
              background-color: #29291E;
              border-radius: 0.015rem
            }
          }
        }
        .yuan {
          color: #6C6C6C;
          text-align: left;
          font-size: .12rem;
          text-decoration: line-through;
          margin-top: -0.05rem;
        }
      }
      .pro_tit {
        font-size: .14rem;
        line-height: .21rem;
        color: #292929;
        text-align: left;
        margin-top: .08rem;
        padding: 0 .15rem;
        font-weight: 650;
        img {
          width: .16rem;
          display: inline-block;
          vertical-align: middle;
          margin-left: .02rem;
        }
      }
    }
    .pro_actinfo {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      .header {
        overflow: hidden;
        height: .44rem;
        line-height: .44rem;
        position: relative;
        .tag {
          width: .36rem;
          height: .17rem;
          line-height: .17rem;
          display: inline-block;
          text-align: center;
          color: #333333;
          font-size: .14rem;
          border-radius: .07rem;
          margin-left: 2%;
          float: left;
          margin-top: .14rem;
          font-weight: 600;
        }
        .acttag{
          height: .22rem;
          line-height: .22rem;
          padding-left: .07rem;
          background: url("/static/images/xbbAct.png");
          background-size: 100% 100%;
          font-size: .12rem;
          color:#fff;
          float: left;
          margin-top: .1rem;
          margin-right: .07rem;
          padding-right: .07rem;
        }
        .title {
          width: 62%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
          margin-left: .05rem;
          font-size: .14rem;
          float: left;
        }
        img {
          float: right;
          margin-top: .2rem;
          margin-right: .14rem;
          width: .18rem;
        }
        .num {
          font-size: .12rem;
          color: #999;
        }
      }
      .con {
        position: relative;
        padding-left: .1rem;
        padding-right: .14rem;
        padding-bottom: .15rem;
        padding-top: .05rem;
        font-size: .14rem;
        .title {
          width: 100%;
          margin-top: .1rem;
          font-size: .12rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
          margin-left: .05rem;
          color: #383333;
        }
      }
      .header::before {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border-bottom: 1px solid #d7d7d7;
        -webkit-transform: scale(.5);
        transform: scale(.5);
      }
    }
    .pro_arg {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      padding: .2rem .11rem;
      .pro_arg_tit {
        font-size: .14rem;
        line-height: .2rem;
        color: #292929;
        font-weight: 500;
      }
      .pro_arg_list {
        margin-top: .14rem;
        font-size: .13rem;
        line-height: .18rem;
        .pro_arg_item {
          margin-top: .12rem;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          span:nth-child(1) {
            color: #A0A0A0;
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            -moz-flex-shrink: 0;
            -ms-flex-shrink: 0;
            -o-flex-shrink: 0;
          }
          span:nth-child(2) {
            color: #383333;
          }
        }
        .pro_arg_more {
          text-align: center;
          color: #999999;
          margin-top: .15rem;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -ms-justify-content: center;
          -o-justify-content: center;
          .van-icon {
            margin-left: 0.04rem;
          }
        }
      }
    }
    .pro_comment {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      padding: .2rem .11rem;
      .pro_comment_tit {
        font-size: .14rem;
        color: #292929;
        font-weight: 600;
        position: relative;
        .pro_comment_more {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          -moz-align-items: center;
          .hp {
            color: #FC0324;
            font-size: .13rem;
            float: left;
            font-weight:400;
          }
          .van-icon-arrow {
            float: left;
          }
        }
      }
      .pro_comment_item {
        margin-top: .2rem;
        .comment_head_info {
          position: relative;
          overflow: hidden;
          .sj {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 9;
            font-size: .12rem;
            .van-icon-star {
              font-size: .13rem;
            }
          }
          .img {
            width: .37rem;
            float: left;
            img {
              width: .37rem;
              height: .37rem;
              border-radius: .37rem;
            }
          }
          .info {
            float: left;
            position: relative;
            left: 0.1rem;
            padding-bottom: 0.1rem;
            .name {
              font-size: .14rem;
              line-height: .2rem;
              /*padding-left: .1rem;*/
              width: 2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              img{
                width: .42rem;
                height: .24rem;
                display: inline-block;
                vertical-align: middle;
                margin-left: -.1rem;
              }
            }

            .time {
              font-size: .1rem;
              /*transform: scale(0.95);*/
              color: #AFB0AF;
              padding-top: 0.03rem;
            }
          }
        }
        .comment_content_info {
          padding-left: .47rem;
          .comment_txt {
            font-size: .14rem;
            line-height: .2rem;
            color: #6D6D6D;
            word-break: break-word;
          }
          .comment_pic {
            margin-top: .1rem;
            .swiper-container {
              width: 100%;
              height: 100%;
              .swiper-slide {
                text-align: center;
                font-size: 18px;
                background: #fff;
                height: .85rem;
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 0.04rem;
                  overflow: hidden;
                  object-fit: cover;
                }
              }
            }

          }
        }
        .comment_oper {
          overflow: hidden;
          .button {
            /*border: solid 1px #606060;*/
            padding: .04rem .08rem;
            display: inline-block;
            border-radius: .15rem;
            font-size: .11rem;
            color: #6D6D6D;
            float: right;
            margin-left: .15rem;
            margin-top: .1rem;
            img {
              width: .16rem;
              height: .16rem;
              display: block;
              float: left;
              margin-right: .05rem;
            }

          }
        }
      }
    }
    .pro_details {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      /*padding-bottom: .2rem;*/
      .pro_details_tit {
        font-size: .14rem;
        color: #292929;
        font-weight: 600;
        padding: .2rem .11rem;
        padding-bottom: .1rem;
      }
      .pro_details_con {
        font-size: .14rem;
        img {
          width: 100% !important;
          height: auto !important;
          display: block;
        }
      }
    }
    .pro_related_goods {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      .pro_related_goods_tit {
        width: 50%;
        margin: 0 auto;
      }
      .pro_related_list {
        padding: 0 .11rem;
        background: #fff;
        overflow: hidden;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -o-flex-wrap: wrap;
        .pro_item:nth-child(2n) {
          padding-left: .035rem;
        }
        .pro_item:nth-child(2n-1) {
          padding-right: .035rem;
        }
      }
      .productbanner {
        div {
          border-radius: 0.04rem;
          height: 0.6rem;
          overflow: hidden;
          margin-top: 0.08rem;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
          }
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
    }
    .pro_goods_menu {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: .49rem;
      background: #fff;
      z-index: 99;
      .iconbtn {
        float: left;
        /*width: 32%;*/
        padding-top: .09rem;
        .kefu {
          float: left;
          margin-left: .28rem;
          img {
            width: .22rem;
            height: .22rem;
            margin: 0 auto;
          }
          .txt {
            font-size: .12rem;
            text-align: center;
            transform: scale(0.75);
            -webkit-transform: scale(0.75);
            -moz-transform: scale(0.75);
            -ms-transform: scale(0.75);
            -o-transform: scale(0.75);
            color: #222222;
          }
        }
        .cart {
          float: left;
          margin-left: .28rem;
          img {
            width: .22rem;
            height: .22rem;
            margin: 0 auto;
          }
          .txt {
            font-size: .12rem;
            text-align: center;
            transform: scale(0.75);
            -webkit-transform: scale(0.75);
            -moz-transform: scale(0.75);
            -ms-transform: scale(0.75);
            -o-transform: scale(0.75);
            color: #222222;
          }
        }
      }
      .button {
        float: right;
        width: 29%;
        color: #fff;
        font-size: .16rem;
        line-height: .38rem;
        text-align: center;
        border-radius:0.19rem;
      }
      .shopcart {
        background: #222222;
        margin-top:0.06rem;
        background:linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-webkit-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-moz-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-ms-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-o-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
      }
      .buy {
        margin-left: 0.08rem;
        margin-right: 0.11rem;
        margin-top:0.06rem;
        background: linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
      }
      .buy.disabled{
        background: #888;
      }
    }
    .sharecontainer {
      position: fixed;
      width: 100%;
      z-index: 100;
      height: 100%;
      left: 0;
      top: 0;
      img {
        position: absolute;
        top: 0;
        right: .35rem;
        width: 1.53rem;
      }
      .know {
        width: 1.09rem;
        height: .36rem;
        line-height: .36rem;
        color: #fff;
        border-color: #fff;
        background: transparent;
        position: absolute;
        bottom: 1.5rem;
        left: 50%;
        margin-left: -.54rem;
      }
    }
    .sure1 {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    }
    .sureGray {
      opacity: 0.38;
    }
    .sure {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      height: .43rem;
      border-radius:.25rem;
      line-height: .22rem;
      font-size: .16rem;
    }
    .parsetime{
      color:#FFCACA;
      font-size: .1rem;
      line-height: .14rem;
      transform: scale(0.85);
    }
    .poster_shadow {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background:rgba(0,0,0,0.69);
      padding: 0 0.14rem;
      z-index: 9999;
      .poster_shadow_swiper {
        font-size: 0;
        width: 87%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .van-loading--spinner {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -295%);
          -webkit-transform: translate(-50%, -295%);
          -moz-transform: translate(-50%, -295%);
          -ms-transform: translate(-50%, -295%);
          -o-transform: translate(-50%, -295%);
          z-index: 1;
        }
        .poster_swiper {
          background: #FFFFFF;
          border-radius: 0.04rem;
          padding-top: 0.22rem;
          margin-bottom: 0.1rem;
          overflow: hidden;
          position: relative;
          .swiper-container {
            width: 100%;
            height: 300px;
            margin-left: auto;
            margin-right: auto;
          }
          .swiper-slide {
            background-size: cover;
            background-position: center;
          }
          .gallery-top {
            /*height: 80%;*/
            width: auto;
            padding-left: 0.12rem;
            padding-right: 0.12rem;
            background: #fff;
            overflow-y: auto;
            &.gallery {
              position: absolute;
              left: 0;
              top: 0.22rem;
              z-index: 1;
            }
            .swiper-slide {
              img {
                width: 100%;
                &.imgCls {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  transform: -webkit-translate(-50%, -50%);
                  transform: -moz-translate(-50%, -50%);
                  transform: -ms-translate(-50%, -50%);
                  transform: -o-translate(-50%, -50%);
                }
                /*height: 100%;*/
                /*border-radius: 0.04rem;*/
              }
              .qrcode {
                /*padding-top: 0.06rem;*/
                /*padding-bottom: 0.13rem;*/
                width: 100%;
                padding: 0.26rem 0.2rem 0.26rem 0.2rem;
                display: flex;
                display: -webkit-flex;
                display: -ms-flex;
                display: -moz-flex;
                display: -o-flex;
                justify-content: space-between;
                -webkit-justify-content: space-between;
                -ms-justify-content: space-between;
                -moz-justify-content: space-between;
                -o-justify-content: space-between;
                /*align-items: center;*/
                /*-webkit-align-items: center;*/
                /*-ms-align-items: center;*/
                /*-moz-align-items: center;*/
                /*-o-align-items: center;*/
                img {
                  /*margin-right: 0.18rem;*/
                }
                p {
                  text-align: left;
                  b {
                    margin-top: 0.04rem;
                    font-weight: 400;
                  }
                }
                .poster-p {
                  display: flex;
                  display: -webkit-flex;
                  display: -moz-flex;
                  display: -ms-flex;
                  display: -o-flex;
                  align-items: flex-end;
                  -webkit-align-items: flex-end;
                  -moz-align-items: flex-end;
                  -ms-align-items: flex-end;
                  -o-align-items: flex-end;
                  margin-top: 0.13rem;
                  b {
                    margin-top: 0;
                    &:first-of-type {
                      font-size:0.22rem;
                      font-weight:600;
                      color:rgba(255,39,66,1);
                      line-height: 0.18rem;
                      &:before {
                        content: '￥';
                        font-size:0.13rem;
                        font-weight:400;
                        font-style: normal;
                        color:rgba(255,39,66,1);
                        line-height: 0.13rem;
                      }
                    }
                    &:nth-of-type(2) {
                      font-size:0.13rem;
                      font-weight:400;
                      font-style: normal;
                      color:rgba(102,102,102,1);
                      line-height: 0.13rem;
                      position: relative;
                      &:after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        width: 100%;
                        height: 0.01rem;
                        background:rgba(102,102,102,1);
                        display: block;
                      }
                    }
                  }
                }
              }
            }
          }
          .gallery-thumbs {
            /*display: none;// 注掉 海报改布局用*/
            padding-top: 0.06rem;
            padding-bottom: 0.13rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            position: absolute;
            left: 0.12rem;
            right: 0;
            bottom: 0.52rem;
            background: #fff;
            .swiper-wrapper {
              height: 100%;
            }
          }
          .gallery-thumbs .swiper-slide {
            overflow: hidden;
            height: 0.93rem;
            width: 0.93rem;
            /*opacity: 0.4;*/
            img {
              width: 100%;
              height: 100%;
            }
          }
          .gallery-thumbs .swiper-slide-thumb-active {
            opacity: 1;
            border: 0.02rem solid #BB9773;
          }
          .botton {
            display: block;
            font-size:0.14rem;
            font-weight:400;
            color:rgba(41,41,41,1);
            line-height:0.51rem;
            text-align: center;
            height: 0.51rem;
            border-top: 0.01rem solid #EFEFEF;
            margin-left: 0.14rem;
            margin-right: 0.13rem;
            margin-top: -0.23rem;
            background: #fff;
            z-index: 100;
            position: relative;
            img {
              width: 0.16rem;
              height: 0.16rem;
              display: inline-block;
              vertical-align: sub;
              margin-right: 0.09rem;
            }
          }
        }
      }
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    .van-action_model {
      height: 70vh;
      .van-item {
        padding: .14rem;
        .tit {
          font-size: .14rem;
          color: #262626;
          font-weight:400;
          line-height: .23rem;
        }
        .con {
          padding-top: .1rem;
          line-height: .23rem;
          font-size: .14rem;
          color: #333333;
        }
      }
      .btn{
        padding: .14rem;
        width: 100%;
        position: fixed;
        bottom: 0;
        left:0;
        .vanbtn{
          width: 100%;
          height: .43rem;
          background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
          border-radius:.25rem;
        }
      }
    }
    .van-action-sheet__close{
      background: url("../../assets/images/closex.png") center no-repeat;
      background-size: .2rem .2rem;
    }
    .presale_info_dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      .dialog {
        width: 79%;
        margin: 0 auto;
        background: #fff;
        border-radius: .04rem;
        height: 2.24rem;
        position: relative;
        .header {
          width: 70%;
          margin: 0 auto;
          font-weight: bold;
          .van-divider {
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            margin: .2rem 0;
            line-height: .24rem;
            border-color: #666666;
            border-style: solid;
            border-width: 0;
            color: #333333;
            font-size: .21rem;
          }
          .van-divider::before, .van-divider::after {
            content: ' ';
            display: block;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;
            box-sizing: border-box;
            height: 1px;
            border-color: inherit;
            border-style: inherit;
            border-width: 0 0 0;
            margin-right: .16rem;
            margin-left: .16rem;
          }
        }
        .content {
          width: 80%;
          margin: 0 auto;
          text-align: center;
          color: #444444;
          font-size: .14rem;
          margin-top: .02rem;
          line-height: .2rem;
          height: 1.2rem;
          overflow-y: auto;
        }
        .btn {
          background: #FC0324;
          width: 50%;
          text-align: center;
          color: #fff;
          font-size: .15rem;
          border-radius: .16rem;
          height: .31rem;
          line-height: .31rem;
          position: absolute;
          left: 25%;
          bottom: .22rem;
        }
      }
    }
    .homeBtn {
      z-index: 10;
      position: fixed;
      right:0.17rem;
      bottom:0.8rem;
      width:0.4rem;
      height:0.4rem;
      border-radius: 50%;
      background:rgba(255,255,255,1);
      box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -webkit-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -moz-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -ms-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -o-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -webkit-flex-direction: column;
      -o-flex-direction: column;
      justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -webkit-justify-content: center;
      -o-justify-content: center;
      align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
        display: block;
      }
    }
    #img {
      position: relative;
      &:after {
        content: '';
        display: block;
        background: url('../../assets/images/posterLogoewm.png') no-repeat center;
        background-size: 100%;
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
      }
    }
  }

</style>
<style lang="scss">
  .productDetail {
    .good_sku {
      .van-icon-cross {
        background: url('../../assets/images/close3.png') no-repeat center;
        background-size: 100%;
        color: transparent;
      }
    }
  }
  .container {
    .good_sku .van-sku-row__item{
      border-radius: .15rem;
      font-size: .13rem;
      color:#5E5E5E;
      padding: 0 .1rem;
      border: solid 1px transparent;
    }
    .good_sku .van-sku-row__item::before{
      background: #EEEFF4;
    }
    .good_sku .van-sku__goods-price{
      margin-top: .2rem;

    }
    .good_sku .van-sku__price-symbol,.van-sku__price-num{
      font-size: .16rem;
      color:#FC0324;
      font-weight: 600;
    }
    .good_sku .van-sku-row__item--active{
      border: solid 1px #FC0324;
      background-color: #FCEDEB;
      color:#FC0324;
    }
    .good_sku .van-sku-row__item-name{
      padding: .06rem;
    }
    .good_sku .van-sku-row__item-img{
      width: .2rem;
      height: .2rem;
    }
    .good_sku.van-popup--bottom.van-popup--round{
      border-radius: 0;
    }
    .good_sku .van-sku-row__title,.van-sku__stepper-title{
      padding-bottom:.13rem;
      font-size: .13rem;
      color:#333333;
      line-height: .18rem;
      font-weight: 600;
    }
    .good_sku .van-sku__stepper{
      border-radius: .13rem;
      overflow: hidden;
    }
    .good_sku .van-stepper__minus, .van-stepper__plus,.van-stepper__input{
      height: .22rem;
    }
    .good_sku .van-stepper__minus::before, .van-stepper__plus::before{
      width: 9px;
    }
    .good_sku .van-stepper__minus::after, .van-stepper__plus::after{
      height: 9px;
    }
    .good_sku .van-sku-row__item--disabled{
      background:#FCFCFC;
      border-radius:.15rem;
      border:1px solid #EEEFF4;
      color:#DEDEDE;
      &:before {
        background:#FCFCFC;
      }
    }
    .pro_details_con {
      font-size: .14rem;
    }
    .pro_details_con img {
      width: 100% !important;
      height: auto !important;
    }
    .pro_details_con .ckeditor-html5-video {
      width: 100%;
    }
    .pro_details_con .ckeditor-html5-video video {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productdetail/msproductDetail.vue